import { styled } from 'linaria/react';

const stockColors = {
  inStock: '#27AE60',
  outOfStock: '#EB5757',
  notifyWhenBack: '#F2C94C',
};

const StockOrb = styled('span')`
  display: inline-block;
  height: 12px;
  width: 12px;
  margin-bottom: -1px;
  border-radius: 50%;
  transition: all 0.2s linear;
  background-color: ${({ status }) => stockColors[status]};
  margin-right: 0.5rem;
`;

export default StockOrb;
